export const passwordAgingConst = 'passwordAging';

export default {
  passwordAgingConst,
};

export const SecurityModalTitles = {
  passwordAging: 'Are you sure you want to continue?',
  passwordLockout: 'You are about to turn off lockout',
};

export const SecurityModalTypes = {
  passwordAging: 'PasswordAging',
  passwordLockout: 'PasswordLockout',
};
